const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Lowest-Cost Electricity Source',
    description: "Wind energy is now Australia's cheapest source of new electricity generation at around $70/MWh — cheaper than coal, gas, and even new large-scale solar in many regions. For industrial users, this translates directly to lower long-term energy costs.",
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    icon: 'ri-landscape-line',
    title: "World-Class Wind Resources",
    description: 'Australia has some of the best wind resources on earth. The southern coastline, Bass Strait, and inland regions of SA, VIC, and WA experience consistent, high-speed winds ideal for large-scale generation. Average capacity factors of 35–45% are common.',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-24-hours-line',
    title: 'Consistent Baseload Complement',
    description: 'Wind energy is generated day and night, unlike solar which only produces during daylight hours. Wind and solar complement each other perfectly — wind often peaks during winter and at night when solar generation is lowest.',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Massive Industrial Scale Possible',
    description: 'Modern commercial wind turbines generate 3–6 MW each. A single turbine can power over 2,000 homes. For large industrial operations, co-located wind assets or Power Purchase Agreements (PPAs) offer predictable, low-cost renewable energy at scale.',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Near-Zero Lifecycle Emissions',
    description: "Wind turbines produce electricity with a lifecycle carbon footprint of 4–7 gCO₂/kWh — among the lowest of any energy source. For manufacturers and exporters facing scope 3 emissions requirements, wind energy contracts directly reduce supply-chain carbon exposure.",
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-community-line',
    title: 'Regional Economic Benefits',
    description: 'Wind farms create significant economic activity in regional Australia — construction jobs, long-term operational roles, landowner lease income, and local council rate revenue. Wind projects are increasingly viewed as a key pillar of regional economic development.',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
];

export default function WindBenefits() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-50 border border-secondary-200/50 mb-5">
            <i className="ri-windy-line text-secondary-600 text-sm"></i>
            <span className="text-xs font-semibold text-secondary-700 tracking-wide uppercase whitespace-nowrap">Why Wind Energy</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Why Wind Energy is Australia&rsquo;s<br className="hidden md:block" /> Commercial Power Advantage
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Wind is the lowest-cost, most scalable renewable energy source available to Australian businesses, industry, and communities today.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {benefits.map((benefit) => (
            <article
              key={benefit.title}
              className="bg-background-100/70 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-secondary-200 hover:bg-background-50 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 rounded-xl ${benefit.bg} flex items-center justify-center mb-5 group-hover:scale-105 transition-transform duration-300`}>
                <i className={`${benefit.icon} text-xl ${benefit.color}`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}